
import { useIOStore } from '~/stores/io'


// Atomic
import Row from '~/components/io/atomic/atoms/Row.vue'
import Column from '~/components/io/atomic/atoms/Column.vue'
import Wrap from '~/components/io/atomic/atoms/Wrap.vue'
import Section from '~/components/io/atomic/atoms/Section.vue'
import Frame from '~/components/io/atomic/atoms/Frame.vue'

// General
import Button from '~/components/Button.vue'
import Spinner from '~/components/Spinner.vue'
import Ellipsis from '~/components/Ellipsis.vue'

// import Logo from '~/components/logos/Logo.vue'
// import LogoDark from '~/components/logos/LogoDark.vue'
// import LogoLight from '~/components/logos/LogoLight.vue'


// import { useHeaderStore } from '@/stores/header'
// import { usePageStore } from '@/stores/page'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Button', Button)
  nuxtApp.vueApp.component('Column', Column)
  nuxtApp.vueApp.component('Row', Row)
  nuxtApp.vueApp.component('Wrap', Wrap)
  nuxtApp.vueApp.component('Section', Section)
  nuxtApp.vueApp.component('Frame', Frame)
  nuxtApp.vueApp.component('Spinner', Spinner)
  nuxtApp.vueApp.component('Ellipsis', Ellipsis)

  // nuxtApp.vueApp.component('Logo', Logo)
  // nuxtApp.vueApp.component('LogoDark', LogoDark)
  // nuxtApp.vueApp.component('LogoLight', LogoLight)

  const io = useIOStore()
  nuxtApp.provide('io',  io)

})
